import styles from "./layout.module.css";
import { Menu, MenuItem, Dialog, Snackbar, Alert } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import { authData } from "./GetAuth";
import dayjs from "dayjs";
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { BarChart2, Calendar, Lock, Menu as MenuIcon, Settings, User } from "react-feather";
import { StorageRemoveItem, STORAGE_KEYS } from "./StorageComp";
import UpdateProfileForm from "./popups/UpdateProfileForm";
dayjs.extend(isSameOrBefore);

const Header = ({ onMenuToggle }) => {
  const auth = authData();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [formOpenUpdateProfile, setFormOpenUpdateProfile] = useState(false);
  const userProfileData = localStorage.getItem("authData");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [loading, setLoading] = useState(false);

  const goMyProfile = () => {
    navigate("/my-profile");
  }

  const goCompanyProfile = () => {
    navigate("/company-profile");
  }

  const goToSubscribe = () => {
    navigate("/subscribe");
  }

  const Logout = () => {
    StorageRemoveItem(STORAGE_KEYS.AUTH);
    navigate("/sign-in");
  }

  return (<header className={`${styles.HeaderMain}`}>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.HeaderMainUnder}`}>
      <div className={`${styles.HeaderRow}`}>
        <button
          type="button"
          className={`${styles.MenuToggle}`}
          aria-label="Toggle navigation menu"
          onClick={onMenuToggle}
        >
          <MenuIcon />
        </button>

        <div className={`${styles.HeadRightSec}`}>
          {/*<button className={`${styles.HeadBU}`}>
            <NotificationsOutlined />
            <span className={`${styles.HeadBUCount}`}>9</span>
          </button>*/}
          <button className={`${styles.ProfileBU}`} onClick={(e) => setAnchorEl(e.currentTarget)}><User /></button>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={(e) => setAnchorEl(null)}
            onClick={(e) => setAnchorEl(null)}
          >
            <div className={`${styles.DropdownProfileSec}`}>
              <div className={`${styles.ProfileAvatar}`}><p>{auth?.name.substring(0, 1)}</p></div>
              <p className={`${styles.ProfileText}`}>{auth?.name}</p>
              <p className={`${styles.ProfileText}`}>{auth?.email}</p>
              <p className={`${styles.ProfileText}`}>{auth?.company?.company_name}</p>
            </div>
            {auth?.user_type !== 1 && <div className={`${styles.DropdownPlanSec}`}>
              <p className={`${styles.DropdownPlanText}`}><BarChart2 />Plan: {auth?.subscription?.name}</p>
              <p className={`${styles.DropdownPlanText}`}><Calendar />{dayjs().isSameOrBefore(auth?.subscription?.end_date, 'date') ? 'Expires On ' : 'Expired On '}{dayjs(auth?.subscription?.end_date).format('MM/DD/YYYY')}</p>
              {auth?.user_type === 2 && <button onClick={goToSubscribe}>Upgrade</button>}
            </div>}
            <MenuItem onClick={goMyProfile} className={`${styles.DropdownProfileLink}`}><Settings />Account Setting</MenuItem>
            {auth?.user_type === 2 && <MenuItem onClick={goCompanyProfile} className={`${styles.DropdownProfileLink}`}><Settings />Company Setting</MenuItem>}
            <MenuItem onClick={Logout} className={`${styles.DropdownProfileLink}`}><Lock />Sign Out</MenuItem>
          </Menu>
        </div>
      </div>
    </div>

    <Dialog open={formOpenUpdateProfile} onClose={(e) => setFormOpenUpdateProfile(false)}>
      <UpdateProfileForm setFormOpenUpdateProfile={setFormOpenUpdateProfile.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} userProfileData={userProfileData} />
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert onClose={(e) => setSnackbarOpen(false)} severity={snackbarType} variant="filled" sx={{ width: "100%" }}>{snackbarMessage}</Alert>
    </Snackbar>
  </header>);
};

export default Header;